import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

function fetchPaymentMethod(sellerId, token) {
  const url = `${apiUrl}/sellers/${sellerId}/payment-method`;

  return request(url, token);
}

export { fetchPaymentMethod };
